import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import withLayout from '../../Layouts/AdminPanel'

const OAuthCallback = () => {
	const history = useHistory()
	const location = useLocation()
	const [countdown, setCountdown] = useState(3)

	useEffect(() => {
		// Clean up OAuth hash fragments (Square/Facebook add #_=_ to URL)
		if (window.location.hash === '#_=_') {
			window.history.replaceState(null, null, window.location.pathname + window.location.search)
		}

		// Parse query parameters
		const params = new URLSearchParams(location.search)
		const status = params.get('status')
		const merchantId = params.get('merchant_id')
		const error = params.get('error')

		if (status === 'success') {
			toast(`Square account connected successfully! Merchant ID: ${merchantId || 'N/A'}`)
		} else if (error) {
			toast(`Failed to connect Square account: ${error}`)
		} else {
			toast('Square OAuth completed with unknown status')
		}

		// Countdown timer
		const timer = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					clearInterval(timer)
					// Redirect to settings or dashboard after countdown
					history.push('/square-integration')
					return 0
				}
				return prev - 1
			})
		}, 1000)

		return () => clearInterval(timer)
	}, [location.search, history])

	const params = new URLSearchParams(location.search)
	const status = params.get('status')
	const merchantId = params.get('merchant_id')
	const error = params.get('error')

	return (
		<div className="oauth-callback-container">
			<div className="callback-card">
				{status === 'success' ? (
					<>
						<div className="success-icon">✓</div>
						<h2>Square Account Connected!</h2>
						<p>Your Square account has been successfully connected.</p>
						{merchantId && (
							<div className="merchant-info">
								<strong>Merchant ID:</strong> {merchantId}
							</div>
						)}
					</>
				) : error ? (
					<>
						<div className="error-icon">✗</div>
						<h2>Connection Failed</h2>
						<p>Failed to connect your Square account.</p>
						<div className="error-message">{error}</div>
					</>
				) : (
					<>
						<div className="info-icon">i</div>
						<h2>Processing...</h2>
						<p>Completing Square OAuth flow.</p>
					</>
				)}

				<div className="redirect-message">Redirecting to Square Integration in {countdown} seconds...</div>

				<button onClick={() => history.push('/square-integration')} className="btn btn-primary">
					Go to Square Integration Now
				</button>
			</div>

			<style jsx="true">{`
				.oauth-callback-container {
					display: flex;
					justify-content: center;
					align-items: center;
					min-height: 80vh;
					padding: 20px;
				}

				.callback-card {
					background: white;
					border-radius: 12px;
					padding: 40px;
					max-width: 500px;
					text-align: center;
					box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
				}

				.success-icon {
					width: 80px;
					height: 80px;
					margin: 0 auto 20px;
					background: #28a745;
					color: white;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 48px;
					font-weight: bold;
				}

				.error-icon {
					width: 80px;
					height: 80px;
					margin: 0 auto 20px;
					background: #dc3545;
					color: white;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 48px;
					font-weight: bold;
				}

				.info-icon {
					width: 80px;
					height: 80px;
					margin: 0 auto 20px;
					background: #17a2b8;
					color: white;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 48px;
					font-weight: bold;
				}

				h2 {
					margin: 0 0 16px 0;
					font-size: 28px;
					font-weight: 600;
					color: #333;
				}

				p {
					margin: 0 0 20px 0;
					color: #666;
					font-size: 16px;
				}

				.merchant-info {
					margin: 20px 0;
					padding: 12px;
					background: #f8f9fa;
					border-radius: 6px;
					color: #333;
				}

				.error-message {
					margin: 20px 0;
					padding: 12px;
					background: #f8d7da;
					border-radius: 6px;
					color: #721c24;
				}

				.redirect-message {
					margin: 24px 0;
					padding: 12px;
					background: #e7f3ff;
					border-radius: 6px;
					color: #004085;
					font-size: 14px;
				}

				.btn {
					padding: 12px 24px;
					border: none;
					border-radius: 6px;
					font-size: 16px;
					font-weight: 500;
					cursor: pointer;
					transition: background 0.2s;
				}

				.btn-primary {
					background: #007bff;
					color: white;
				}

				.btn-primary:hover {
					background: #0056b3;
				}
			`}</style>
		</div>
	)
}

export default withLayout(OAuthCallback)
